import { hasPermission } from "../../utils/permissions";
export const canManageAuthentication = (user) =>
  user?.isMaster === true ||
  hasPermission(user, "GERENCIAR_AUTENTICACOES_ASSINATURAS");
export const authenticationLabels = {
  NOT_STARTED: "Não iniciada",
  DRAFT: "Em preenchimento",
  PENDING: "Em análise",
  APPROVED: "Habilitada",
  CORRECTION: "Reenvio solicitado",
  BLOCKED: "Bloqueada",
  REJECTED: "Rejeitada",
  REVOKED: "Desabilitada",
  EXPIRED: "Expirada",
};
export function exportAuthenticationCsv(rows, documents = false) {
  const cell = (value) =>
    '"' +
    String(value ?? "")
      .replace(/^[\s]*[=+@-]/, "'$&")
      .replace(/"/g, '""') +
    '"';
  const header = documents
    ? [
        "Documento",
        "Solicitante",
        "Situação",
        "Assinaturas",
        "Total",
        "Criado em",
      ]
    : [
        "Nome",
        "E-mail",
        "CPF",
        "Situação",
        "Solicitação",
        "Atualizado em",
        "Motivo",
      ];
  const body = rows.map((r) =>
    documents
      ? [r.title, r.requester, r.status, r.signed, r.total, r.createdAt]
      : [
          r.name,
          r.email,
          r.cpf,
          authenticationLabels[r.status] || r.status,
          r.requestedField,
          r.updatedAt,
          r.note,
        ],
  );
  const url = URL.createObjectURL(
    new Blob(
      [
        "\ufeff" +
          [header, ...body]
            .map((line) => line.map(cell).join(";"))
            .join("\r\n"),
      ],
      { type: "text/csv;charset=utf-8" },
    ),
  );
  const link = document.createElement("a");
  link.href = url;
  link.download = documents
    ? "relatorio-assinaturas.csv"
    : "relatorio-autenticacoes.csv";
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
